import React, { useState, useEffect, useRef, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./Monitoring.css";
import Playlandmarks from "../../components/playlandmarks/Playlandmarks";
import { Context } from "../../context/Context";

const Monitoring = (props) => {

  const navigate = useNavigate();
  const {patientMonitoringData, setPatientMonitoringData, contentMonitoringLoaded, setContentMonitoringLoaded} = useContext(Context);

  // const [patientMonitoringData, setPatientMonitoringData] = useState([]);
  const [dateInUse, setDateInUse] = useState("y");
  const [isNewUser, setIsNewUser] = useState(false);
  const [adminName, setAdminName] = useState("");

  useEffect(() => {
    localStorage.removeItem("patientName");
    setIsNewUser(
      localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
        ? JSON.parse(localStorage.getItem("userData")).is_new_user === 1
          ? true
          : false
        : false
    );
    setAdminName(
      localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
        ? JSON.parse(localStorage.getItem("userData")).first_name
        : "[fName]"
    );
  }, []);

  let dateToday = new Date();
  let dateYesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  let dateShow = moment(dateYesterday).format("l");
  const [dateCompT] = useState(dateToday.toString().split(" ").splice(0, 4).join());
  const [dateCompY] = useState(dateYesterday.toString().split(" ").splice(0, 4).join());

  const [patientDate, setDate] = useState(dateShow);
  const [startProgram, setStartProgram] = useState(dateShow);
  const [search, setSearch] = useState("");
  const [isSorted, setSorted] = useState(true);
  const [isOpenCalendar, setOpenCalendar] = useState(false);
  // const [contentMonitoringLoaded, setContentMonitoringLoaded] = useState(false);
  const searchBy = useRef("");
  const holdScroll = useRef("");
  const wrapperRef = useRef("");

  useEffect(() => {
    getUpcomingDates();
    // eslint-disable-next-line
  }, [patientDate]);

  const [graphOpen, setGraphOpen] = useState(-1);

  const openCloseGraph = (i, graphData, color) => {
    if (graphOpen === -1 || graphOpen !== i) {
      setGraphOpen(i);
      setPainScaleHistory(graphData);
      setPainScaleColor(color);
    } else if (graphOpen === i) {
      setGraphOpen(-1);
    }
  };

  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    // setContentMonitoringLoaded(false);
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      const getData = setTimeout(() => {
        loadMonitoring();
      }, 1000);
      return () => clearTimeout(getData);
    }
    // eslint-disable-next-line
  }, [patientDate, search]);

  const loadMonitoring = () => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_dashboard/my-monitoring", {
        date: patientDate,
        search: search.trim(),
      })
      .then((res) => {
        if (res.data.responseData) {
          var response = res.data.responseData;
          setPatientMonitoringData(response);
          setContentMonitoringLoaded(true);
          props.checkLoggedIn(true);
          if (graphOpen > -1) {
            setPainScaleHistory(response[graphOpen].chart_data);
            setPainScaleColor(response[graphOpen].chart_color);
          }
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
          props.checkLoggedIn(false);
        }
      });
  };

  const updateSearchQuery = (value) => {
    setContentMonitoringLoaded(false);
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "") {
      setSearch("");
    }
  };

  const setDateSearch = (param) => {
    setContentMonitoringLoaded(false);
    setDateInUse(param);
    if (param === "y") {
      let date = new Date().setDate(new Date().getDate() - 1);
      setDate(moment(date).format("l"));
    } else {
      setDate(moment(new Date()).format("l"));
    }
  };

  const setDateManually = (param) => {
    setContentMonitoringLoaded(false);
    if (param === "backwards") {
      let date = new Date(patientDate).setDate(new Date(patientDate).getDate() - 1);
      let dateComp = new Date(date).toString().split(" ").splice(0, 4).join();
      if (dateComp === dateCompT) {
        setDateInUse("t");
      } else if (dateComp === dateCompY) {
        setDateInUse("y");
      } else if (moment(dateComp) > moment(dateCompT)) {
        setDateInUse("future");
      } else if (moment(dateComp) < moment(dateCompT)) {
        setDateInUse("past");
      }
      setDate(moment(date).format("l"));
    } else if (param === "forward") {
      if (dateInUse === "t") {
        return false;
      }

      let date = new Date(patientDate).setDate(new Date(patientDate).getDate() + 1);
      let dateComp = new Date(date).toString().split(" ").splice(0, 4).join();
      if (dateComp === dateCompT) {
        setDateInUse("t");
      } else if (dateComp === dateCompY) {
        setDateInUse("y");
      } else if (moment(dateComp) > moment(dateCompT)) {
        setDateInUse("future");
      } else if (moment(dateComp) < moment(dateCompT)) {
        setDateInUse("past");
      }
      setDate(moment(date).format("l"));
    }
  };

  const [upcomingDates, setUpcomingDates] = useState([]);

  const getUpcomingDates = () => {
    var allDatesArr = [];
    var dateLoop = new Date(patientDate);
    for (var i = 0; i < 15; i++) {
      let date = new Date(dateLoop).setDate(new Date(dateLoop).getDate() - i);
      date = moment(date).format("M/D");
      allDatesArr.unshift(date);
    }
    setUpcomingDates(allDatesArr);
  };

  const [painScaleHistory, setPainScaleHistory] = useState([]);
  const [painScaleColor, setPainScaleColor] = useState([]);

  /*function smallScaleObj(chartData, chartColor) {
    return {
      title: {
        text: "",
      },
      chart: {
        style: {
          fontFamily: "Epilogue",
        },
        height: 50,
      },
      xAxis: {
        maxPadding: 0,
        type: "datetime",
        categories: upcomingDates,
        tickmarkPlacement: "on",
        lineWidth: 0,
        labels: {
          enabled: false,
        },
      },
      yAxis: {
        maxPadding: 0,
        max: 10,
        title: {
          text: "",
        },
        labels: {
          enabled: false,
        },
        tickLength: 0,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        area: {
          lineColor: chartColor,
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, Highcharts.color(chartColor).setOpacity(0.7).get("rgba")],
              [1, Highcharts.color(chartColor).setOpacity(0).get("rgba")],
            ],
          },
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: false,
              },
            },
          },
          lineWidth: 1,
          threshold: null,
        },
      },
      series: [
        {
          animation: false,
          type: "area",
          states: {
            hover: {
              enabled: false,
            },
          },
          pointPlacement: "on",
          name: "Pain Level",
          data: chartData,
        },
      ],
    };
  }*/
  
  /*const lablesSize = ;*/
	  
const lablesSize = window.innerWidth < 1600 ? {rotation: -45, step: 2, y: 30, x: -3, overflow: "allow"} : {rotation: 0, y: 30, x: -3, overflow: "allow"};

const painScaleObj = {
    title: {
      text: "",
    },
    chart: {
      style: {
        fontFamily: "Epilogue",
      },
      backgroundColor: "#f7fafb",
      height: 300,
    },
    xAxis: {
      type: "datetime",
      categories: upcomingDates,
      tickmarkPlacement: "on",
      lineWidth: 2,
      labels: lablesSize,
    },
    yAxis: {
      max: 10,
      title: {
        text: "",
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      area: {
        lineColor: painScaleColor,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, Highcharts.color(painScaleColor).setOpacity(0.5).get("rgba")],
            [1, Highcharts.color(painScaleColor).setOpacity(0).get("rgba")],
          ],
        },
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        lineWidth: 3,
        threshold: null,
      },
    },
    series: [
      {
        type: "area",
        pointPlacement: "on",
        name: "Pain Level",
        data: painScaleHistory,
      },
    ],
  };

  const openCalendar = (isOpen) => {
    setOpenCalendar(!isOpen);
  };

  const handleScroll = useCallback(() => {
    setOpenCalendar(false);
  }, []);

  useEffect(() => {
    const scrl = holdScroll.current;
    scrl.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    const eventSource = new EventSource(
      window.ajaxLink + "updatesse/events?observeData=refreshDashboard&valueName=" + userData.id.toString()
    );
    eventSource.onmessage = (e) => {
      if (
        e.data.toString().toLowerCase() === "update" &&
        moment(new Date(patientDate)).format("l") === moment(new Date()).format("l")
      ) {
        loadMonitoring(userData);
      }
    };
    return () => {
      eventSource.close();
    };
    // eslint-disable-next-line
  }, []);

  function useOutsideCalenderAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenCalendar(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideCalenderAlerter(wrapperRef);

  const updateDate = (newDate) => {
    setDate(moment(newDate).format("l"));
    let dateComp = new Date(newDate).toString().split(" ").splice(0, 4).join();

    if (moment().isSameOrAfter(newDate) === false) {
      setDateInUse("future");
    } else {
      setDateInUse("past");
    }

    if (dateComp === dateCompT) {
      setDateInUse("t");
    } else if (dateComp === dateCompY) {
      setDateInUse("y");
    }
  };

  const handleSorting = (column, array) => {
    setGraphOpen(-1);
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setPatientMonitoringData(sorted);
  };

  const [isTaskInfoOpen, setTaskInfoOpen] = useState(false);
  const [taskInfoLoaded, setTaskInfoLoaded] = useState(false);
  const [tasksInfo, setTaskInfo] = useState({});
  const [tasksCompleteYesterday, setTasksCompleteYesterday] = useState(0);
  // eslint-disable-next-line
  const [totalTasks, setTotalTasks] = useState(0);
  const [painLvlDate, setPainLvlDate] = useState(new Date());
  const [painToolHeight, setPainToolHeight] = useState(0);
  const [painToolLeft, setPainToolLeft] = useState(0);
  const [totalCountOfTasks, setTotalCountOfTasks] = useState(0);
  const [orderActivities, setOrderActivities] = useState(false);
  // eslint-disable-next-line
  const [afterOpenData, setAfterOpenData] = useState("");
  const [showToday, setShowToday] = useState(false);

  const handleOrderActivities = () => {
    setOrderActivities(!orderActivities);
    // eslint-disable-next-line
    Object.values(tasksInfo).map((val) => {
      // eslint-disable-next-line
      val.map((activity) => {
        if (!orderActivities) {
          activity?.activity_data &&
            activity.activity_data.sort(function (a, b) {
              if (a["is_complete"] > b["is_complete"]) {
                return -1;
              }
              if (a["is_complete"] < b["is_complete"]) {
                return 1;
              }
              return 0;
            });
        } else {
          activity?.activity_data &&
            activity.activity_data.sort(function (a, b) {
              if (a["id"] > b["id"]) {
                return 1;
              }
              if (a["id"] < b["id"]) {
                return -1;
              }
              return 0;
            });
        }
      });
    });
  };

  // useEffect(() => {}, [orderActivities]);
  const [cancelToken, setCancelToken] = useState(null);

  const openCloseTaskInfo = (event, programData, isToday = false) => {
    setTotalCountOfTasks(0);
    setTasksCompleteYesterday(0);
    setTaskInfoLoaded(false);

    event.stopPropagation();
    if (!isTaskInfoOpen) {
      const source = axios.CancelToken.source();
      setCancelToken(source);
      setAfterOpenData(programData);
      setStartProgram(programData.start_date);
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(
          window.ajaxLink + "cloud_dashboard/tasks-detailed-info",
          {
            patient_id: programData.patient_id,
            date_search: patientDate,
          },
          { cancelToken: source.token }
        )
        .then((res) => {
          if (res.data.responseData) {
            const formattedByDay = res.data.responseData.reduce((acc, task) => {
              const date = task.moved_date;
              acc[date] = [...(acc[date] || []), task];
              return acc;
            }, {});
            if (isToday) {
              const todayDate = moment(patientDate).format("YYYY-MM-DD");
              const formattedByDayCopy = { ...formattedByDay };
              const today = formattedByDayCopy[todayDate];
              const todayObj = {};
              if (today) {
                todayObj[todayDate] = today;
                setTaskInfo(todayObj);
                let completedToday = 0;
                for (var oneTsk of today) {
                  if (oneTsk?.is_complete === 1) {
                    completedToday++;
                  }
                }
                setTasksCompleteYesterday(completedToday);
                setTotalCountOfTasks(today.length);
              }

              setShowToday(true);
            } else {
              const ordered = Object.keys(formattedByDay)
                .sort()
                .reduce((obj, key) => {
                  obj[key] = formattedByDay[key];
                  return obj;
                }, {});

              setTaskInfo(ordered);
              setShowToday(false);

              var completedTsk = 0;
              for (var oneTsk1 of res.data.responseData) {
                if (oneTsk1.is_complete === 1) {
                  completedTsk++;
                }
              }
              setTasksCompleteYesterday(completedTsk || programData.tasks_complete_yesterday);
              setTotalTasks(programData.tasks_total_yesterday || 0);
              setTotalCountOfTasks(res.data.responseData.length);
            }
            setTaskInfoLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    setTaskInfoOpen(true);
  };

  const closePopup = (event) => {
    event.stopPropagation();
    setOrderActivities(false);
    setTaskInfo({});
    setTaskInfoLoaded(false);
    setSingleExrDataOpen(-1);
    setTasksCompleteYesterday(0);
    setTotalTasks(0);
    setTaskInfoOpen(false);
    if (cancelToken) {
      cancelToken.cancel("Request cancelled by user");
      setCancelToken(null);
    }
  };

  const openCloseExr = (i, date) => {
    let tasksInfoCopy = { ...tasksInfo };
    let openedTask = tasksInfoCopy[date];
    let objectToOpen = openedTask[i];
    let stateOpened = objectToOpen.opened;
    let update = { ...objectToOpen, opened: !stateOpened };
    for (const k in tasksInfoCopy) {
      let obj = tasksInfoCopy[k];
      for (const t of obj) {
        t.opened = false;
      }
    }
    openedTask[i] = update;
    tasksInfoCopy[date] = openedTask;
    setTaskInfo(tasksInfoCopy);
  };
  const [singleExrDataOpen, setSingleExrDataOpen] = useState(-1);
  const openCloseExrData = (i) => {
    if (singleExrDataOpen === -1 || singleExrDataOpen !== i) {
      setSingleExrDataOpen(i);
    } else if (singleExrDataOpen === i) {
      setSingleExrDataOpen(-1);
    }
  };

  const [videoOpen, setVideoOpen] = useState(false);
  const openPlayVideo = (i) => {
    if (!videoOpen && i !== false) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_dashboard/load-mp-landmarks", { exercise_id: i })

        .then((res) => {
          if (res.data.responseData) {
            var resp = res.data.responseData;
            if (resp.s3_link) {
              getMPDataFromS3(resp.s3_link);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }

    setVideoOpen(!videoOpen);
  };

  const getMPDataFromS3 = (link) => {
	window.mpLoad = link;
  };

  const handleViewMessages = (patient_id, patientName) => {
    navigate("/messages/" + patient_id);
    localStorage.setItem("patientName", patientName);
  };

  const handleViewProfile = (patient_id, program_id) => {
    localStorage.setItem("from_dash", true);
    navigate("/patient-details/" + patient_id + "/" + program_id);
  };

  const handleEditProgram = (program_id) => {
    navigate("/details/" + program_id);
  };

  const handleAddQuest = () => {
    navigate("/questionnaires");
  };

  const handlePainTool = (item, event) => {
    if (item === "close") {
      setPainToolHeight(0);
      setPainToolLeft(0);
    } else {
      setPainLvlDate(item.pain_level_date);
      setPainToolHeight(event.clientY - 80 - event.nativeEvent.layerY);
      setPainToolLeft(event.target.offsetLeft);
    }
  };

  const handleModal = () => {
    var keepToken = JSON.parse(localStorage.getItem("userData")).token;
    var tokenExpire = JSON.parse(localStorage.getItem("userData")).tokenExpire;

    axios.defaults.headers.common["Authorization"] = keepToken;
    axios
      .post(window.ajaxLink + "cloud_therapist/updateAdminNewStatus", {})
      .then((res) => {
        if (res.data.responseCode === 200) {
          res.data.responseData.userData.token = keepToken;
          res.data.responseData.userData.tokenExpire = tokenExpire;
          localStorage.setItem("userData", JSON.stringify(res.data.responseData.userData));
          setIsNewUser(false);
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
          props.checkLoggedIn(false);
        }
      });
  };



  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const updateContainerWidth = () => {
      const holdElement = document.querySelector(".monitoring_hold");
      if (holdElement) {
        const newWidth = holdElement.offsetWidth - 48; 
        setContainerWidth(newWidth);
      }
    };

    updateContainerWidth(); 

    window.addEventListener("resize", updateContainerWidth); 

    return () => {
      window.removeEventListener("resize", updateContainerWidth); 
    };
  }, []);

  return (
    <>
    
    {painToolHeight > 0 && painToolLeft > 0 && (
        <>
          <div
            className="dash_tooltip dash_tooltip_isolated"
            style={{
              top: painToolHeight + "px",
              left: painToolLeft + "px",
              display: setPainToolHeight ? "block" : "none",
            }}
          >
            <div className="dash_tooltip_text">at {moment(painLvlDate).format("LTS")}</div>
            <div className="dash_arrow"></div>
          </div>
        </>
      )}
      <div ref={holdScroll} className="monitoring_hold">
        <div className="dash_box_title">Remote Monitoring</div>

        <div className="dash_box_menu">
          <div onClick={() => searchBy.current.focus()} className="dash_box_search_hold">
            <input
              type="text"
              ref={searchBy}
              placeholder="Enter Patient name, problem area or status..."
              className="dash_box_search"
              onChange={() => updateSearchQuery(searchBy.current.value)}
            />
            <div className="dash_box_search_icon"></div>
          </div>
          <div className="dash_box_filter_area">
            <div
              className={"dash_box_filter_btn" + (dateInUse === "y" ? " btn_fill" : " btn_no_fill")}
              onClick={() => setDateSearch("y")}
            >
              Yesterday
            </div>
            <div
              className={"dash_box_filter_btn dbf_no_marg " + (dateInUse === "t" ? " btn_fill" : " btn_no_fill")}
              onClick={() => setDateSearch("t")}
            >
              Today
            </div>
            <div className="dash_box_cali_filter h-full flex-row align-stretch w-max">
              {!isOpenCalendar ? (
                <div className="cali_signifier" onClick={() => openCalendar(isOpenCalendar)}></div>
              ) : (
                <div className="cali_signifier_closed"></div>
              )}
              <div className="cali_date h-full w-max">{patientDate}</div>
              <div className="cali_icon to_left" onClick={() => setDateManually("backwards")}></div>
              <div
                className={"cali_icon to_right " + (dateInUse === "t" ? "btn_disabled" : "")}
                onClick={() => setDateManually("forward")}
              ></div>
            </div>
            <div className="dash_box_filter_menu"></div>
          </div>
        </div>
        {isOpenCalendar && (
          <div ref={wrapperRef} className="calendar_contain" style={{zIndex: 99999}}>
            <Calendar
              onChange={updateDate}
              value={new Date(patientDate)}
              formatShortWeekday={(locale, date) => ["S", "M", "T", "W", "T", "F", "S"][date.getDay()]}
              calendarType={"US"}
              maxDate={new Date()}
              view={"month"}
            />
          </div>
        )}



        <div
          className="monitoring_table_container"
          style={{ maxWidth: `${containerWidth}px` }}
        >
          <div className="monitoring_table_inner_container">
          {/* <div className="holder_table_and_rows_overflow" > */}
          {contentMonitoringLoaded ? 
          <>
          <div className="programs_table">
          <div className="dash_box_sort_rows">
            <div className="dash_box_sort_option">
              <div className="dash_box_sort_title">Name</div>
              <div className="dash_box_sort_icon" onClick={() => handleSorting("patient_name", patientMonitoringData)}></div>
            </div>
            <div className="dash_box_sort_option status_flex_correction">
              <div className="dash_box_sort_title status_title_option">Status</div>
              <div className="dash_box_sort_icon" onClick={() => handleSorting("patient_status", patientMonitoringData)}></div>
            </div>
            <div className="dash_box_sort_option">
              <div className="dash_box_sort_title">Problem</div>
              <div className="dash_box_sort_icon" onClick={() => handleSorting("problem_name", patientMonitoringData)}></div>
            </div>
            <div className="dash_box_sort_option">
              <div className="dash_box_sort_title">Pain</div>
              <div className="dash_box_sort_icon" onClick={() => handleSorting("pain_level", patientMonitoringData)}></div>
            </div>
            {/* <div className="dash_box_sort_option">
            <div className="dash_box_sort_title progress_row_inf">Progress</div>
            <div className="information_line">
              <div className="dash_tooltip_hold_information_line">
                <div className="dash_tooltip_information_line">
                  <div>
                    <div className="target_focus_img"></div>
                    <div className="dash_tooltip_text_monitoring">Actual vs. Possible workout points</div>
                  </div>
                  <div>
                    <div className="line_chart_img"></div>
                    <div className="dash_tooltip_text_monitoring">This week vs. Last week workout points</div>
                  </div>
                </div>
                <div className="dash_arrow"></div>
              </div>
            </div>
            <div className="dash_box_sort_icon" onClick={() => handleSorting("total_tasks_points", patientMonitoringData)}></div>
          </div> */}
            <div className="dash_box_sort_option length_wks_flex_correction">
              <div className="dash_box_sort_title">Length Wks</div>
              <div className="dash_box_sort_icon" onClick={() => handleSorting("days_in", patientMonitoringData)}></div>
            </div>
            <div className="dash_box_sort_option">
              <div className="dash_box_sort_title tasks_row_inf">Activities</div>
              <div className="information_line_tasks">
                <div className="dash_tooltip_hold_information_line_tasks">
                  <div className="dash_tooltip_information_line">
                    <div>
                      <div className="calender_line_img"></div>
                      <div className="dash_tooltip_text_monitoring">Activities completed</div>
                    </div>
                    <div>
                      <div className="line_chart_img"></div>
                      <div className="dash_tooltip_text_monitoring">Activity results</div>
                    </div>
                  </div>
                  <div className="dash_arrow"></div>
                </div>
              </div>
              <div
                className="dash_box_sort_icon"
                onClick={() => handleSorting("tasks_total_yesterday", patientMonitoringData)}
              ></div>
            </div>

            {/*<div className="dash_box_sort_option">
          <div className="dash_box_sort_title">Progress</div>
          <div className="dash_box_sort_icon" onClick={() => handleSorting("tasks_complete", patientMonitoringData)}></div>
      </div>*/}
          </div>
        </div>
          {patientMonitoringData.length > 0 && contentMonitoringLoaded === true ? (
            <div className="dash_box_table">
              {patientMonitoringData.map((item, i) => (
                <div key={i}>
                  <div  className={"dash_box_row_container" + (graphOpen === i ? " dbox_row_act" : "")}>
                    <div className="dash_box_row_info">
                      <div
                        className="d_row dash_box_appointee"
                        onClick={() => handleViewProfile(item.patient_id, item.program_id)}
                      >
                        {item.patient_name}
                      </div>
                      <div className="status_row_pain_vector">
                        <div
                          className={
                            "dash_box_status_color" +
                            (item.patient_status === 3
                              ? " pain_color_green"
                              : item.patient_status === 2
                              ? " pain_color_yellow"
                              : item.patient_status === 1
                              ? " pain_color_red"
                              : item.patient_status === 0 && " pain_color_gray")
                          }
                        >
                          <div className="dash_tooltip_hold dash_tooltip_hold_margin_status activity_table_tooltip">
                            <div className="dash_tooltip">
                              <div className="dash_tooltip_text">
                                {item.patient_status === 3
                                  ? "Normal"
                                  : item.patient_status === 2
                                  ? "Caution"
                                  : item.patient_status === 1
                                  ? "Urgent"
                                  : item.patient_status === 0 && "Pending"}
                              </div>
                            </div>
                            <div className="dash_arrow"></div>
                          </div>
                        </div>
                      </div>
                      <div className="d_row dash_box_problem px-1">
                        <div>{item.problem_name}</div>
                        <div>{item.sub_problem_name}</div>
                      </div>
                      <div
                        className="d_row dash_box_pains"
                        onClick={() => openCloseGraph(i, item.chart_data, item.chart_color)}
                      >
                        <div>
                          <div className="pain_level_in_dash_box">{item.pain_level}</div>
                          <div
                            className={
                              item.pain_level_difference < 0
                                ? " arrow_pain_green_down"
                                : item.pain_level_difference > 0
                                ? " arrow_pain_red_up"
                                : "arrow_pain_green_down"
                            }
                          ></div>
                          <div
                            className={
                              item.pain_level_difference < 0
                                ? " pain_pts_green"
                                : item.pain_level_difference > 0
                                ? " pain_pts_red"
                                : "pain_pts_green"
                            }
                          >
                            {item.pain_level_difference ? item.pain_level_difference : "+" + 0} pts
                          </div>
                        </div>
                        <div
                          className="pain_date_in_dash_box"
                          onMouseOver={(e) => handlePainTool(item, e)}
                          onMouseLeave={() => handlePainTool("close")}
                        >
                          on {moment(item.pain_level_date).format("L")}
                        </div>
                      </div>
                      {/*<div className="d_row dash_box_pain">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={smallScaleObj(item.chart_data, item.chart_color)}
                    />
                  </div>*/}
                      {/* <div className="d_row dash_box_progress">
                      <div>
                        <div className="actual_and_possible_img"></div>
                        <div className="actual_and_possible_points">
                          {item.actual_tasks_points ? item.actual_tasks_points : 0}/
                          {item.total_tasks_points ? item.total_tasks_points : 0}
                        </div>
                        <div className="arrow_pain_green_up"></div>
                        <div className="pain_pts_green">{item.actual_trend_points} pts</div>
                      </div>
                      <div className="this_week_and_last_week_contain">
                        <div className="this_week_and_last_week_img"></div>
                        <div className="actual_and_possible_points">
                          {item.this_week_points ? item.this_week_points : 0}/
                          {item.last_week_points ? item.last_week_points : 0}
                        </div>
                      </div>
                    </div> */}
                      {/*<div className="d_row dash_box_target">
                    <div
                      className={
                        "dash_box_target_circle ap_color" +
                        (item.target_rom ? Math.round(item.target_rom / 2) * 2 : "0")
                      }
                    ></div>
                  </div>*/}
                      <div className="d_row length_weeks">{item.weeks_in === 0 ? 1 : item.weeks_in} Wks</div>
                      <div className="d_row tasks_row">
                        <div>
                          <div
                            className="this_week_and_last_week_content today_activities_content"
                            onClick={(e) => openCloseTaskInfo(e, item, true)}
                          >
                            <div className="tasks_calendar_img"></div>
                            <div className="actual_and_possible_points">
                              {item.tasks_complete_today}/{item.tasks_total_today}
                            </div>
                            <div className="dash_tooltip_hold_information_line_tasks_secound today_activities_content_tooltip">
                              <div style={{ width: "285px" }} className="dash_tooltip_information_line">
                                <div style={{ marginBottom: "10px" }}>
                                  <div className="calender_line_img"></div>
                                  <div style={{ width: "79%" }} className="dash_tooltip_text_monitoring">
                                    Activities completed/assigned for {moment(patientDate, "MM/DD/YYYY").format("l")}
                                  </div>
                                </div>
                                {/* <div>
                                  <div className="line_chart_img"></div>
                                  <div style={{ width: "79%" }} className="dash_tooltip_text_monitoring">
                                    Activities completed/assigned from {moment(item.start_date).format("l")}-
                                    {moment(item.end_date).format("l")}
                                  </div>
                                </div> */}
                              </div>
                              <div className="dash_arrow"></div>
                            </div>
                          </div>
                          {/* <div className="arrow_pain_green_up"></div>
                        <div className="pain_pts_green">
                          {item.tasks_yesterday_trend ? item.tasks_yesterday_trend : "+" + 0}
                          {" pts"}
                        </div> */}
                          {/* <div className="dash_tooltip_hold_information_line_tasks_secound">
                            <div style={{ width: "285px" }} className="dash_tooltip_information_line">
                              <div style={{ marginBottom: "10px" }}>
                                <div className="calender_line_img"></div>
                                <div style={{ width: "79%" }} className="dash_tooltip_text_monitoring">
                                  Activities completed/assigned for {moment(patientDate).format("l")}
                                </div>
                              </div>
                              <div>
                                <div className="line_chart_img"></div>
                                <div style={{ width: "79%" }} className="dash_tooltip_text_monitoring">
                                  Activities completed/assigned from {moment(item.start_date).format("l")}-
                                  {moment(item.end_date).format("l")}
                                </div>
                              </div>
                            </div>
                            <div className="dash_arrow"></div>
                          </div> */}
                        </div>
                        <div className="this_week_and_last_week_contain" onClick={(e) => openCloseTaskInfo(e, item)}>
                          <div className="this_week_and_last_week_content total_activities_content">
                            <div className="this_week_and_last_week_img"></div>
                            <div className="actual_and_possible_points">
                              {item.actual_tasks_points ? item.actual_tasks_points : 0}/
                              {item.total_tasks_points ? item.total_tasks_points : 0}
                            </div>
                            <div className="dash_tooltip_hold_information_line_tasks_secound total_activities_content_tooltip">
                              <div style={{ width: "285px" }} className="dash_tooltip_information_line">
                                {/* <div style={{ marginBottom: "10px" }}>
                                <div className="calender_line_img"></div>
                                <div style={{ width: "79%" }} className="dash_tooltip_text_monitoring">
                                  Activities completed/assigned for {moment(patientDate).format("l")}
                                </div>
                              </div> */}
                                <div>
                                  <div className="line_chart_img"></div>
                                  <div style={{ width: "79%" }} className="dash_tooltip_text_monitoring">
                                    {(() => {
                                      const isMMDDYYYY = moment(item?.start_date, "MM/DD/YYYY", true).isValid();
                                      const startDate = isMMDDYYYY
                                        ? moment(item?.start_date, "MM/DD/YYYY").format("l")
                                        : moment(item?.start_date, "YYYY-MM-DD").format("l");

                                      const endDate = moment(patientDate, "MM/DD/YYYY").format("l");

                                      return (
                                        <>Activities completed/assigned from {startDate} - {endDate}</>
                                      );
                                    })()}
                                  </div>
                                </div>
                              </div>
                              <div className="dash_arrow"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="appointment_more_dash">
                        <div className="appointment_more_container_monitoring">
                          <div
                            onClick={() => handleViewProfile(item.patient_id, item.program_id)}
                            className="appointment_more_menu"
                          >
                            View Patient File
                          </div>
                          <div
                            onClick={() => handleViewMessages(item.patient_id, item.patient_name)}
                            className="appointment_more_menu"
                          >
                            View Messages
                          </div>
                          <div 
                            style={{ marginBottom: "0px" }}
                            onClick={() => handleEditProgram(item.program_id)} className="appointment_more_menu">
                            Edit Recovery Plan
                          </div>
                          {/* <div
                            style={{ marginBottom: "0px" }}
                            onClick={() => handleAddQuest(item.program_id)}
                            className="appointment_more_menu"
                          >
                            Add Questionnaire
                          </div> */}
                        </div>
                      </div>
                      {/*<div className="d_row">
                    <div className="dash_box_progress_bar">
                      <div
                        style={{
                          width: (item.tasks_complete / item.total_tasks) * 100 + "%",
                        }}
                        className="dash_box_progress_bar progress_done"
                      ></div>
                    </div>
                      </div>*/}
                    </div>
                    {/*<div className="dash_box_row_rest">
                  <div className="d_row_ever_present ep_arrow"></div>
                  <div className="d_row_ever_present ep_more"></div>
                      </div>*/}
                  </div>
                  {graphOpen === i && (
                    <div className="d_row_detailed_info">
                      <div className="d_row_left_side">
                        <div className="d_row_detailed_title">Pain Level Progress</div>
                        <div className="d_row_graph_area">
                          <HighchartsReact highcharts={Highcharts} options={painScaleObj} />
                        </div>
                        {/* {                  <div className="d_row_graph_area">
                      <div className="d_row_plot_area">
                        <div className="d_row_top_value">10</div>
                        <div className="d_graph_plot_line"></div>
                      </div>
                      <div className="d_row_plot_area">
                        <div className="d_row_top_value">06</div>
                        <div className="d_graph_plot_line"></div>
                      </div>
                      <div className="d_row_plot_area">
                        <div className="d_row_top_value">04</div>
                        <div className="d_graph_plot_line"></div>
                      </div>
                      <div className="d_row_plot_area d_plot_area_last">
                        <div className="d_row_top_value d_row_last_val">0</div>
                        <div className="d_graph_plot_line p_line_bold"></div>
                      </div>
                      <div className="d_bottom_values_hold">
                        {upcomingDates.map((item, i) => (
                          <div key={i} className="d_bottom_value">
                            {moment(item).format("M/D")}
                          </div>
                        ))}
                      </div>
                      <div className="d_graph_visual dg_visual8">
                        <div className="d_graph_dots_hold">
                          
                          {painScaleHistory.map((item, i) => (
                            <>
                              <div
                                key={i + "angle"}
                                className="dg_angle_of_attack"
                                style={{
                                  height: (item / 10) * 100 + "%",
                                  top:
                                    "calc(" +
                                    ((10 - item) / 10) * 100 +
                                    "% - 3px)",
                                }}
                              ></div>
                              <div className="dg_hypoth"></div>
                              <div
                                key={i}
                                className="d_graph_dot"
                                style={{
                                  height:
                                    ((painScaleHistory[i + 1] > item
                                      ? painScaleHistory[i + 1] - item
                                      : item - painScaleHistory[i + 1]) /
                                      10) *
                                      100 +
                                    "%",
                                  top:
                                    ((10 -
                                      item -
                                      (painScaleHistory[i + 1] > item
                                        ? painScaleHistory[i + 1] - item
                                        : 10 -
                                          painScaleHistory[i - 1] +
                                          item)) /
                                      10) *
                                      100 +
                                    "%",
                                }}
                              ></div>
                            </>
                          ))}
                        </div>
                        <div className="d_graph_main_line"></div>
                      </div>
                    </div>} */}
                      </div>
                      <div className="d_row_right_side">
                        <div className="d_row_detailed_title">Pain Level Score</div>
                        <div className="d_graph_explain">
                          <div className="d_pain_lvl d_pain_white">0</div>
                          <div className="d_pain_lvl_text">No Pain</div>
                        </div>
                        <div className="d_graph_explain">
                          <div className="d_pain_lvl d_pain_green">2</div>
                          <div className="d_pain_lvl_text">Mild Pain</div>
                        </div>
                        <div className="d_graph_explain">
                          <div className="d_pain_lvl d_pain_yellow">4</div>
                          <div className="d_pain_lvl_text">Moderate Pain</div>
                        </div>
                        <div className="d_graph_explain">
                          <div className="d_pain_lvl d_pain_blue">6</div>
                          <div className="d_pain_lvl_text">Severe Pain</div>
                        </div>
                        <div className="d_graph_explain">
                          <div className="d_pain_lvl d_pain_red">8</div>
                          <div className="d_pain_lvl_text">Most Severe Pain</div>
                        </div>
                        <div className="d_graph_explain">
                          <div className="d_pain_lvl d_pain_black">10</div>
                          <div className="d_pain_lvl_text">Unbearable Pain</div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="dash_box_table_no_res">
              <div className="dash_no_results">
                    <div className="dash_no_results_img"></div>
                    <div className="dash_no_results_text_large">You have no patients to monitor.</div>
                    <div className="dash_no_results_text_regular">You have 0 active patients assigned to you.</div>{" "}
              </div>
            </div>
          )}
          </>
          :
          <>
          <div className="dash_box_table_no_res">
                  <div className="p_load"></div>
            </div>
          </>
          }
          {/* </div> */}
          </div>
        </div>


        {isTaskInfoOpen && (
          <div className="dlt_wrapper">
            <div className="approval_close tsk_info_cls" onClick={(e) => closePopup(e)}></div>
            <div className="dash_task_info_pop">
              <div className="dash_task_info_title">Activities</div>
              <div className="dash_task_main_desc">
                {taskInfoLoaded && (
                  <>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap'}}>
                      <div className="dash_task_image"></div>
                      <div className="dash_task_desc_title">
                        Activities Assigned{" "}
                        {!showToday
                          ? " from " + moment(startProgram).format("l") + " to " + moment(patientDate).format("l")
                          : " for Today"}
                      </div>
                    </div>
                    <div style={{flex: 1, display: 'flex', flexDirection: 'row', gap: '10px', flexWrap: 'wrap'}}>
                    <div>
                      {tasksInfo && Object.keys(tasksInfo).length > 0 &&
                        <>
                        <div
                        className={"prog_temp_save" + (orderActivities ? " prog_temp_checked" : "")}
                        onClick={(e) => handleOrderActivities(e)}
                      ></div>
                      Order by activities done
                      </>
                      }
                    </div>
                    <div className="dash_task_desc_nums">
                      {tasksCompleteYesterday} / {totalCountOfTasks}
                    </div>
                    </div>
                  </>
                )}
              </div>
              {taskInfoLoaded ? (
                <div className="dash_task_table" style={{overflowX: 'auto'}}>
                  <div style={{minWidth: "1000px"}}>
                  {tasksInfo && Object.keys(tasksInfo).length > 0 ? (
                    <>
                      <div className="dash_task_single_row dash_task_sr_no_bord">
                        <div style={{ flex: "0.25 1 1%" }} className="dash_task_reg dash_task_single_desc">
                          Activity
                        </div>
                        <div style={{ flex: "0.3 1" }} className="dash_task_reg dash_task_single_desc">
                          Status
                        </div>
                        <div className="dash_task_reg dash_task_single_desc">Name</div>
                        <div className="dash_task_reg dash_task_single_desc">Details</div>
                        <div className="dash_task_reg dash_task_single_desc">Assigned Date</div>
                        <div className="dash_task_reg dash_task_single_desc">Time Completed</div>
                      </div>
                      {Object.entries(tasksInfo).map(([date, taskData]) => (
                        <div key={date}>
                          <p className="dash_task_desc_title" style={{ fontSize: "14px" }}>
                            {moment(date).format("L")}
                          </p>
                          <>
                            {taskData?.map((task, tsk) => (
                              <div key={tsk}>
                                <div
                                  className={"dash_task_single_row" + (task.opened ? " dt_sr_open" : "")}
                                  onClick={() => (task.task_type === 1 ? openCloseExr(tsk, date) : "")}
                                >
                                  <div style={{ flex: "0.2 1 1%" }} className="dash_task_reg">
                                    <div
                                      className={
                                        "dash_task_type " +
                                        (task.category_type === 3
                                          ? "dsh_task_funct"
                                          : task.task_type === 1
                                          ? "dsh_task_1"
                                          : task.task_type === 2
                                          ? "dsh_task_2"
                                          : task.task_type === 3
                                          ? "dsh_task_3"
                                          : task.task_type === 4
                                          ? "dsh_task_4"
                                          : "")
                                      }
                                    >
                                      <div className="dash_tooltip_hold">
                                        <div className="dash_tooltip">
                                          <div className="dash_tooltip_text">
                                            {task.category_type === 3
                                              ? "Range of Motion Test"
                                              : task.task_type === 1
                                              ? "PT Session"
                                              : task.task_type === 2
                                              ? "Educational"
                                              : task.task_type === 3
                                              ? "Questionnaire"
                                              : task.task_type === 4 && "Pain Scale"}
                                          </div>
                                        </div>
                                        <div className="dash_arrow"></div>
                                      </div>
                                    </div>
                                    {/* {task.category_type === 3
                                    ? "Functional"
                                    : task.task_type === 1
                                    ? "Home Exercise"
                                    : task.task_type === 2
                                    ? "Educational"
                                    : task.task_type === 3
                                    ? "Questionnaire"
                                    : task.task_type === 4
                                    ? "Pain Scale"
                                    : ""} */}
                                  </div>
                                  <div style={{ flex: "0.4 1" }} className="dash_task_reg">
                                    <div
                                      className={
                                        "status_tasks_position marging_on_left" +
                                        (task.completed_status === "Completed"
                                          ? " pain_color_green"
                                          : task.completed_status === "Skipped"
                                          ? " pain_color_red"
                                          : " pain_color_gray")
                                      }
                                    >
                                      <div className="dash_tooltip_hold">
                                        <div className="dash_tooltip">
                                          <div className="dash_tooltip_text">
                                            {task.completed_status === "Completed"
                                              ? "Completed"
                                              : task.completed_status === "Partially completed"
                                              ? "Partial"
                                              : task.completed_status === "Incomplete"
                                              ? "Pending"
                                              : task.completed_status === "Skipped"
                                              ? "Skipped"
                                              : "Pending"}
                                          </div>
                                        </div>
                                        <div className="dash_arrow"></div>
                                      </div>
                                      {/* {task.completed_status == "Completed" || task.completed_status == "Partially completed"
                                    ? moment(task.completed_date).format("h:mm A zz")
                                    : ""} */}
                                    </div>
                                  </div>
                                  <div className="dash_task_reg_holder dash_task_reg_holder_resized" style={{overflow: 'hidden'}}>
                                    <div className="dash_task_reg">{task.name}</div>
                                  </div>
                                  {/* <div className="dash_task_expand">{task.name}</div> */}
                                  <div className="dash_task_reg">
                                    {task.activity_data
                                      ? task.activity_data.length + " Exercises"
                                      : task.task_type === 2
                                      ? task.duration + " minute read"
                                      : task.task_type === 3
                                      ? task.questions_number + " questions"
                                      : task.task_type === 4
                                      ? task.pain_level === false
                                        ? "How much pain?"
                                        : task.pain_level
                                      : ""}
                                  </div>
                                  <div className="dash_task_reg">{task.suggested_date ? task.suggested_date : ""}</div>
                                  <div className="dash_task_reg">
                                    {task.completed_status === "Completed" ||
                                    task.completed_status === "Partially completed"
                                      ? task.completed_date
                                        ? moment(task.completed_date).format("h:mm A zz")
                                        : ""
                                      : ""}
                                  </div>

                                  {/* <div className="dash_task_reg">{task.description}</div> */}

                                  {/* <div className="dash_task_reg">
                                  {task.completed_status && (
                                    <div
                                      className={
                                        "dash_result_emphasis dash_res_" + task.completed_status.toLowerCase().split(" ")[0]
                                      }
                                    >
                                      {task.completed_status == "pain_up" ? (
                                        <div className="arrow_pain_red_up"></div>
                                      ) : task.completed_status == "pain_dn" ? (
                                        <div className="arrow_pain_green_down"></div>
                                      ) : (
                                        ""
                                      )}
                                      {task.completed_status == "pain_up" || task.completed_status == "pain_dn"
                                        ? task.pain_level_difference + "pts"
                                        : task.completed_status}
                                    </div>
                                  )}
                                </div> */}
                                </div>
                                {task.opened && (
                                  <div className="dash_exr_info">
                                    <div className="dash_task_single_row dt_sr_no_bord_bold dt_bord_addit">
                                      <div className="dt_rep">
                                        <div className="dt_shrink">#</div>
                                      </div>
                                      <div className="dash_task_expand dt_exp2 task_exrc_centered dash_task_exrc_name">
                                        Exercise Name
                                      </div>
                                      <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                        Completed Reps
                                        <div className="dt_sd_addit_desc task_exrc_centered">Actual vs. Target</div>
                                      </div>
                                      <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                        Average Hold
                                        <div className="dt_sd_addit_desc task_exrc_centered">
                                          Actual vs Target vs Previous
                                        </div>
                                        <div className="dt_sd_addit_desc task_exrc_centered">In seconds</div>
                                      </div>
                                      <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                        Time per Rep
                                        <div className="dt_sd_addit_desc task_exrc_centered">Actual vs Previous</div>
                                        <div className="dt_sd_addit_desc task_exrc_centered">In seconds</div>
                                      </div>
                                      <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                        Range of Motion
                                        <div className="dt_sd_addit_desc task_exrc_centered">
                                          Actual vs Target vs Previous
                                        </div>
                                        <div className="dt_sd_addit_desc task_exrc_centered">In Degrees</div>
                                      </div>
                                    </div>
                                    {task.activity_data &&
                                      task.activity_data.map((activity, act) => (
                                        <div key={act}>
                                          <div
                                            className={
                                              "dash_task_single_row dash_task_sr_marg" +
                                              (singleExrDataOpen === act ? " dt_sd_sub_open" : "")
                                            }
                                            onClick={() => {
                                              if (activity.is_complete === 1 && activity.activity_skipped === 0) {
                                                openCloseExrData(act);
                                              }
                                            }}
                                          >
                                            <div className="dt_shrink_in_col">
                                              {act + 1}
                                              {activity.hasVideo > 0 && (
                                                <div
                                                  className="smallPlay"
                                                  onClick={() => openPlayVideo(activity.id)}
                                                ></div>
                                              )}
                                              <div
                                                className={
                                                  "status_exercise_position" +
                                                  (activity.is_complete === 1 && activity.activity_skipped === 0
                                                    ? " pain_color_green"
                                                    : activity.activity_skipped === 1
                                                    ? " pain_color_red"
                                                    : " pain_color_gray")
                                                }
                                              >
                                                <div className="dash_tooltip_hold dash_tooltip_hold_margin_status">
                                                  <div className="dash_tooltip">
                                                    <div className="dash_tooltip_text">
                                                      {activity.is_complete === 1 && activity.activity_skipped === 0
                                                        ? "Completed"
                                                        : activity.activity_skipped === 1
                                                        ? "Skipped"
                                                        : "Pending"}
                                                    </div>
                                                  </div>
                                                  <div className="dash_arrow"></div>
                                                </div>
                                              </div>
                                              {activity.exercise_difficulty > 0 && (
                                                <div className="status_exercise_difficulty ">
                                                  {activity.exercise_difficulty === 1
                                                    ? "H"
                                                    : activity.exercise_difficulty === 2
                                                    ? "E"
                                                    : activity.exercise_difficulty === 3
                                                    ? "P"
                                                    : ""}

                                                  <div className="dash_tooltip_hold dash_tooltip_hold_margin_status">
                                                    <div className="dash_tooltip">
                                                      <div className="dash_tooltip_text">
                                                        {activity.exercise_difficulty === 1
                                                          ? "Hard"
                                                          : activity.exercise_difficulty === 2
                                                          ? "Easy"
                                                          : activity.exercise_difficulty === 3
                                                          ? "Perfect"
                                                          : ""}
                                                      </div>
                                                    </div>
                                                    <div className="dash_arrow"></div>
                                                  </div>
                                                </div>
                                              )}
                                              {activity.activity_skipped === 1 && (
                                                <div
                                                  className={
                                                    "status_exercise_pain" +
                                                    (activity.was_painful === 1
                                                      ? " square_color_red"
                                                      : " square_color_green")
                                                  }
                                                >
                                                  <div className="dash_tooltip_hold dash_tooltip_hold_margin_status">
                                                    <div className="dash_tooltip">
                                                      <div className="dash_tooltip_text">
                                                        {activity.was_painful === 1 ? "Painful" : "Not painful"}
                                                      </div>
                                                    </div>
                                                    <div className="dash_arrow"></div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                            <div className="dash_task_expand dt_exp2 task_exrc_centered">
                                              {activity.display_name}
                                            </div>
                                            <div className="dash_task_reg task_exrc_centered">
                                              {activity.reps_done}/{activity.reps}
                                            </div>
                                            {activity.hold_in_seconds > 0 ? (
                                              <div className="dash_task_reg task_exrc_centered">
                                                {activity.hold_done} / {activity.hold_in_seconds} /{" "}
                                                {activity.previous_hold}
                                              </div>
                                            ) : (
                                              <div className="dash_task_reg task_exrc_centered">No Hold</div>
                                            )}
                                            {activity.is_complete === 1 && activity.activity_skipped === 0 ? (
                                              <div className="dash_task_reg task_exrc_centered">
                                                {activity.rep_seconds}/{activity.rep_seconds_previous}
                                              </div>
                                            ) : (
                                              <div className="dash_task_reg task_exrc_centered">-</div>
                                            )}
                                            {activity.is_complete === 1 &&
                                            activity.activity_skipped === 0 &&
                                            activity.target_rom > 0 ? (
                                              <div className="dash_task_reg task_exrc_centered">
                                                {activity.rom_max}
                                                {"\xB0"}/{activity.target_rom}
                                                {"\xB0"}/{activity.rom_maxPrev > 0 ? activity.rom_maxPrev : "NA"}
                                                {"\xB0"}
                                              </div>
                                            ) : (
                                              <div className="dash_task_reg task_exrc_centered">N/A</div>
                                            )}
                                          </div>
                                          {singleExrDataOpen === act &&
                                            activity.is_complete === 1 &&
                                            activity.activity_skipped === 0 && (
                                              <div className="dash_additional_info">
                                                <div className="dash_task_single_row dt_sr_no_bord_bold dt_no_bord_addit">
                                                  {/* <div className="dt_shrink2">Rep#</div> */}
                                                  <div className="dt_rep">
                                                    <div className="dt_shrink">#</div>
                                                  </div>
                                                  <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                                    Actual Hold vs Target vs Previous
                                                    <div className="dt_sd_addit_desc task_exrc_centered">
                                                      In seconds
                                                    </div>
                                                  </div>
                                                  <div className="dash_task_reg dt_time_rep task_exrc_centered">
                                                    Time per Rep In Seconds
                                                    {/* <div className="dt_in_secs">(In Seconds)</div> */}
                                                  </div>
                                                  <div className="dash_task_reg dt_sd_sub dt_act_rom_target task_exrc_centered">
                                                    Actual ROM vs Target vs Previous
                                                    <div className="dt_sd_addit_desc task_exrc_centered">
                                                      In Degrees
                                                    </div>
                                                    {/* <div className="dt_in_degrees">(In Degrees)</div> */}
                                                  </div>
                                                </div>
                                                {activity.repsData !== undefined && activity.repsData.length > 0 ? (
                                                  <div>
                                                    {activity.repsData.map((rep, r) => (
                                                      <div
                                                        key={rep.id}
                                                        className="dash_task_single_row dash_task_sr_no_bord dash_task_sr_marg_btm"
                                                      >
                                                        {/* <div className="dt_shrink_in_col2">{rep.rep_num}</div> */}
                                                        <div className="dash_task_reg dt_rep">{rep.rep_num}</div>
                                                        {activity.hold_in_seconds > 0 ? (
                                                          <div className="dash_task_reg task_exrc_centered">
                                                            {rep.rep_hold} / {activity.hold_in_seconds} /{" "}
                                                            {activity.previous_hold}
                                                          </div>
                                                        ) : (
                                                          <div className="dash_task_reg task_exrc_centered">
                                                            No Hold
                                                          </div>
                                                        )}
                                                        <div className="dash_task_reg task_exrc_centered">
                                                          {rep.rep_time}
                                                        </div>
                                                        {activity.target_rom > 0 ? (
                                                          <div className="dash_task_reg task_exrc_centered">
                                                            {rep.rep_rom}
                                                            {"\xB0"}/{activity.target_rom}
                                                            {"\xB0"}/
                                                            {activity.rom_maxPrev > 0 ? activity.rom_maxPrev : "NA"}
                                                            {"\xB0"}
                                                          </div>
                                                        ) : (
                                                          <div className="dash_task_reg task_exrc_centered">N/A</div>
                                                        )}
                                                      </div>
                                                    ))}
                                                  </div>
                                                ) : (
                                                  <div className="dash_task_single_row dash_task_sr_no_bord dash_task_sr_marg_btm">
                                                    <div className="dash_task_reg dt_rep">1</div>
                                                    {activity.hold_in_seconds > 0 ? (
                                                      <div className="dash_task_reg task_exrc_centered">
                                                        {activity.hold_done} / {activity.hold_in_seconds} /{" "}
                                                        {activity.previous_hold}
                                                      </div>
                                                    ) : (
                                                      <div className="dash_task_reg task_exrc_centered">No Hold</div>
                                                    )}
                                                    <div className="dash_task_reg task_exrc_centered">
                                                      {activity.rep_seconds}.{activity.rep_seconds_previous}
                                                    </div>
                                                    {activity.target_rom > 0 ? (
                                                      <div className="dash_task_reg task_exrc_centered">
                                                        {activity.rom_max}
                                                        {"\xB0"}/{activity.target_rom}
                                                        {"\xB0"}/
                                                        {activity.rom_maxPrev > 0 ? activity.rom_maxPrev : "NA"}
                                                        {"\xB0"}
                                                      </div>
                                                    ) : (
                                                      <div className="dash_task_reg task_exrc_centered">N/A</div>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                  </div>
                                )}
                              </div>
                            ))}
                          </>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="dash_task_data_empty">No data available.</div>
                  )}
                  </div>
                </div>
              ) : (
                <div className="p_load"></div>
              )}
            </div>
          </div>
        )}

        <div style={videoOpen ? {} : { display: "none" }}>
          <Playlandmarks videoLandmarks={videoOpen} doClose={() => openPlayVideo(false)} />
        </div>

        {isNewUser && (
          <div className="dlt_wrapper company-admin-modal">
            <div style={{top: '50%', transform: 'translate(-50%, -50%)'}} className="dbl_place_on_page">
              <div className="dlt_surround ">
                <div className="welcome-image"></div>
                <div className="dlt_title">
                  Welcome <span>{adminName}</span>!
                </div>
                <div className="dlt_description">
                  Your administrator will assign patients to you, so that you can monitor their care from your Virdio
                  Health dashboard.
                </div>
                <div className="dlt_exit_btm">
                  <div className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn" onClick={handleModal}>
                    Go to Dashboard
                  </div>
                </div>
              </div>
            </div>
            <div className="approval_close tsk_info_cls" onClick={handleModal}></div>
          </div>
        )}

      </div>
    </>
  );
};

export default Monitoring;
